<script>
  import FormTinymce from '../../../../../app/components/form/Tinymce.vue'
  import FormCancelButton from '../../../../../app/components/form/CancelButton.vue'
  import ValidationMessage from '../../../../components/form/ValidationMessage.vue'

  import * as restfulService from '../../../../services/restfulService'
  import * as notifyService from '../../../../services/notifyService'
  import DataService from '../../../../services/dataService'

  import {required, requiredIf, email, url} from 'vuelidate/lib/validators'
  import helpers from '@mixins/helper'
  import {clone, uniq} from 'lodash'
  import bus from '@utils/bus'

  export default {
    name: 'event-basic-data',
    components: {FormTinymce, FormCancelButton, ValidationMessage},
    mixins: [helpers],
    props: ['eventId'],
    data () {
      return {
        isSubmitted: false,
        isLoadingData: true,
        isSearchingMonitors: false,
        dependencies: {
          places: [],
          events: [],
          users: [],
          monitors: [],
          layouts: []
        },
        event: {
          event_id: '',
          title: '',
          place_id: '',
          start_datetime: '',
          end_datetime: '',
          start_registration_datetime: '',
          end_registration_datetime: '',
          contact_email: '',
          max_submissions_per_author: '',
          has_material: false,
          website: '',
          description: '',
          layout_id: '',
          vacancies: 0,
          workload: 0,
          coordinators: [],
          support_committee: [],
          monitors: []
        }
      }
    },
    computed: {
      isSubEvent: function () {
        return this.event.event_id !== null && this.event.event_id !== ''
      }
    },
    mounted () {
      const id = this.$route.params.id || null
      this.getDependencies().then(() => {
        this.loadData(id)
        if (this.eventId) {
          this.$set(this.event, 'event_id', this.eventId)
          this.changeEvent()
        }
      })
    },
    watch: {
      '$route.params.id': function (id) {
        this.loadData(id)
      }
    },
    validations: {
      event: {
        title: {required},
        type_id: {required},
        place_id: {required},
        start_datetime: {required},
        end_datetime: {required},
        start_registration_datetime: {required},
        end_registration_datetime: {required},
        contact_email: {email},
        website: {url},
        vacancies: {required},
        coordinators: {
          required: requiredIf(function () {
            return this.isSubEvent
          })
        }
      }
    },
    methods: {
      getDependencies () {
        return new Promise((resolve) => {
          DataService.get([{domain: 'place'}, {domain: 'event'}, {domain: 'user'}, {domain: 'layout'}, {domain: 'event_type'}]).then((result) => {
            this.dependencies = {...this.dependencies, ...result}
            resolve()
          })
        })
      },
      loadData (id) {
        bus.$emit('show-loader')
        if (id) {
          this.isEdit = true
          restfulService.get('event', null, id, null, ['coordinators', 'support_committee', 'monitors'])
            .then(response => {
              if (response.description === null) {
                response.description = ''
              }
              let coordinators = response.coordinators.map(item => item.user_id)
              let supportCommittee = response.support_committee.map(item => item.user_id)
              let monitors = response.monitors.map(item => item.user_id)
              let monitorsRefPessoa = response.monitors.map(item => item.user.ref_pessoa)
              response.coordinators = [...uniq(coordinators)]
              response.support_committee = [...uniq(supportCommittee)]
              response.monitors = [...uniq(monitors)]
              this.event = response
              this.getMonitors(monitorsRefPessoa)
              this.isLoadingData = false
              bus.$emit('hide-loader')
            })
            .catch(e => {
              console.log(e)
              bus.$emit('hide-loader')
              this.isLoadingData = false
            })
        } else {
          bus.$emit('hide-loader')
          this.isLoadingData = false
        }
      },
      searchMonitors (query) {
        query = parseInt(query)
        if (query > 0) {
          this.getMonitors([query])
        }
      },
      getMonitors (ids) {
        this.dependencies.monitors.splice(0)
        if (ids.length > 0) {
          this.isSearchingMonitors = true
          let data = {
            'person': {has: [{ref_pessoa: {in: ids}}]},
            'status': {has: [{key: {in: ['em_aberto', 'sem_custo', 'pago']}}]},
            'modalities.event_modality': {has: [{event_id: this.event.id}]}
          }
          restfulService.search('registration', null, data, null, ['person'], 1, 20)
            .then((response) => {
              this.dependencies.monitors = uniq([...this.dependencies.monitors, ...response.data])
              this.isSearchingMonitors = false
            })
            .catch(e => {
              console.log(e)
            })
        }
      },
      changeEvent () {
        const event = this.dependencies.events.filter(item => item.id === this.event.event_id)
        if (event.length) {
          this.event.start_registration_datetime = event[0].start_registration_datetime
          this.event.end_registration_datetime = event[0].end_registration_datetime
        }
      },
      onSaveBasicData () {
        this.isSubmitted = true
        const data = clone(this.event)
        data.start_datetime = this.dateTimeFormat(data.start_datetime, 'en')
        data.end_datetime = this.dateTimeFormat(data.end_datetime, 'en')
        data.start_registration_datetime = this.dateTimeFormat(data.start_registration_datetime, 'en')
        data.end_registration_datetime = this.dateTimeFormat(data.end_registration_datetime, 'en')
        restfulService.save('event', null, null, data)
          .then(response => {
            notifyService.success({hideLoader: true})
            this.isSubmitted = false
            this.$router.push({name: 'event.update.basic-data', params: {id: response.id}})
          })
          .catch(e => {
            this.isSubmitted = false
            console.log(e)
          })
      }
    }
  }
</script>

<template>
    <el-form ref="formEvent"
             :model="event"
             label-position="top">
        <el-row>
          <el-col>
              <el-form-item label="Evento Pai">
                  <el-select v-model="event.event_id"
                              filterable
                              clearable
                              @change="changeEvent"
                              placeholder="Selecione um evento"
                              empty-text="Nenhum registro encontrado"
                              class="el-select-full">
                      <el-option
                              v-for="item in dependencies.events"
                              :key="item.id"
                              :label="item.title"
                              :value="item.id">
                      </el-option>
                  </el-select>
              </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col :span="24">
                <el-form-item label="Título"
                              class="is-required"
                              v-bind:class="{ 'el-form-item--error': $v.event.title.$error }">
                    <el-input v-model="event.title"
                              @input="$v.event.title.$touch()"/>
                    <validation-message v-if="!$v.event.title.required && $v.event.title.$dirty"/>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="Tipo de Evento"
              class="is-required"
              v-bind:class="{ 'el-form-item--error': $v.event.type_id.$error }">
              <el-select v-model="event.type_id"
                        class="el-select-full"
                        filterable
                        clearable
                        placeholder="Selecione o tipo de evento"
                        empty-text="Nenhum registro encontrado"
                        @input="$v.event.type_id.$touch()">
                  <el-option v-for="item in dependencies.event_types"
                            :key="item.id"
                            :label="item.description"
                            :value="item.id">
                  </el-option>
                  <validation-message v-if="$v.event.type_id.$error"/>
              </el-select>
              <div class="el-form-item__error" v-if="$v.event.type_id.$error">
                  Esse campo é obrigatório
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
              <el-form-item label="Local"
                            class="is-required"
                            v-bind:class="{ 'el-form-item--error': $v.event.place_id.$error }">
                  <el-select v-model="event.place_id"
                              filterable
                              clearable
                              placeholder="Selecione um local"
                              empty-text="Nenhum registro encontrado"
                              class="el-select-full"
                              @input="$v.event.place_id.$touch()">
                      <el-option
                              v-for="item in dependencies.places"
                              :key="item.id"
                              :label="item.description"
                              :value="item.id">
                      </el-option>
                      <validation-message v-if="$v.event.place_id.$error"/>
                  </el-select>
                  <div class="el-form-item__error" v-if="$v.event.place_id.$error">
                      Esse campo é obrigatório
                  </div>
              </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col :span="12">
                <el-form-item label="Data/Hora Início Evento"
                              class="is-required"
                              v-bind:class="{ 'el-form-item--error': $v.event.start_datetime.$error }">
                    <el-date-picker
                            v-model="event.start_datetime"
                            type="datetime"
                            format="dd/MM/yyyy HH:mm"
                            placeholder="Data/Hora Início"
                            @input="$v.event.start_datetime.$touch()"/>
                    <validation-message v-if="!$v.event.start_datetime.required && $v.event.start_datetime.$dirty"/>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="Data/Hora Término Evento"
                              class="is-required"
                              v-bind:class="{ 'el-form-item--error': $v.event.end_datetime.$error }">
                    <el-date-picker
                            v-model="event.end_datetime"
                            type="datetime"
                            format="dd/MM/yyyy HH:mm"
                            placeholder="Data/Hora Término"
                            @input="$v.event.end_datetime.$touch()"/>
                    <validation-message v-if="!$v.event.end_datetime.required && $v.event.end_datetime.$dirty"/>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col :span="12">
                <el-form-item label="Data/Hora Início Inscrições"
                              class="is-required"
                              v-bind:class="{ 'el-form-item--error': $v.event.start_registration_datetime.$error }">
                    <el-date-picker
                            v-model="event.start_registration_datetime"
                            type="datetime"
                            format="dd/MM/yyyy HH:mm"
                            placeholder="Data/Hora Início Inscrições"
                            @input="$v.event.start_registration_datetime.$touch()"/>
                    <validation-message
                            v-if="!$v.event.start_registration_datetime.required && $v.event.start_registration_datetime.$dirty"/>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="Data/Hora Término Inscrições"
                              class="is-required"
                              v-bind:class="{ 'el-form-item--error': $v.event.end_registration_datetime.$error }">
                    <el-date-picker
                            v-model="event.end_registration_datetime"
                            type="datetime"
                            format="dd/MM/yyyy HH:mm"
                            placeholder="Data/Hora Término Inscrições"
                            @input="$v.event.end_registration_datetime.$touch()"/>
                    <validation-message
                            v-if="!isSubEvent && !$v.event.end_registration_datetime.required && $v.event.end_registration_datetime.$dirty"/>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col :span="12">
                <el-form-item label="Email de Contato"
                              v-if="!isSubEvent"
                              class="is-required"
                              v-bind:class="{ 'el-form-item--error': $v.event.contact_email.$error && !isSubEvent }">
                    <el-input type="email"
                              v-model="event.contact_email"
                              @input="$v.event.contact_email.$touch()"/>
                    <validation-message
                            v-if="!$v.event.contact_email.email"
                            message="O e-mail precisa ser válido."/>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="Material aos participantes?">
                    <el-switch v-model="event.has_material"
                               active-text="SIM"
                               inactive-text="NÃO">
                    </el-switch>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col :span="8">
                <el-form-item label="Nº máximo de submissões por autor"
                              v-if="!isSubEvent"
                              class="is-required">
                    <el-input-number v-model="event.max_submissions_per_author"
                                     :min="0"
                                     :step="1"
                                     :max="100"/>
                </el-form-item>
            </el-col>
            <el-col :span="8">
                <el-form-item label="Nº máximo de vagas"
                              class="is-required"
                              v-if="isSubEvent"
                              v-bind:class="{ 'el-form-item--error': $v.event.vacancies.$error }">
                    <el-input-number v-model="event.vacancies"
                                     :min="0"
                                     :step="1"
                                     :max="20000"/>
                </el-form-item>
                <validation-message v-if="$v.event.vacancies.$error"/>
            </el-col>
            <el-col :span="8">
                <el-form-item label="Carga Horária">
                    <el-input-number v-model="event.workload"
                                     :min="0"
                                     :step="1"
                                     :max="1000"/>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col :span="12">
                <el-form-item :label="!isSubEvent ? 'Site do Evento' : 'Link do Regulamento'"
                              class="is-required"
                              v-bind:class="{ 'el-form-item--error': $v.event.website.$error }">
                    <el-input type="url"
                              v-model="event.website"
                              @input="$v.event.website.$touch()"/>
                    <validation-message
                            v-if="!$v.event.website.url"
                            message="O link precisa ser válido."/>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="Layout do Certificado do Participante">
                    <el-select v-model="event.layout_id"
                               filterable
                               clearable
                               placeholder="Selecione um Layout"
                               empty-text="Nenhum registro encontrado"
                               class="el-select-full">
                        <el-option
                                v-for="item in dependencies.layouts"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-col>
        </el-row>
        <el-form-item label="Coordenadores"
                      v-if="isSubEvent"
                      class="is-required"
                      v-bind:class="{ 'el-form-item--error': $v.event.coordinators.$error }">
            <el-select v-model="event.coordinators"
                       class="el-select-full"
                       filterable
                       multiple
                       clearable
                       placeholder="Selecione os coordenadores"
                       empty-text="Nenhum registro encontrado"
                       @input="$v.event.coordinators.$touch()">
                <el-option v-for="item in dependencies.users"
                           :key="item.id"
                           :label="item.pessoa.nome +' ('+item.ref_pessoa+')'"
                           :value="item.id">
                </el-option>
            </el-select>
            <validation-message v-if="$v.event.coordinators.$error"/>
        </el-form-item>
        <el-form-item label="Comissão de Apoio"
                      v-if="!isSubEvent">
            <el-select v-model="event.support_committee"
                       class="el-select-full"
                       filterable
                       multiple
                       clearable
                       placeholder="Selecione os membros da comissão"
                       empty-text="Nenhum registro encontrado">
                <el-option v-for="item in dependencies.users"
                           :key="item.id"
                           :label="item.pessoa.nome +' ('+item.ref_pessoa+')'"
                           :value="item.id">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="Descrição">
            <form-tinymce id="editorContent"
                          v-model="event.description"
                          :configs="{height: 300}"/>
        </el-form-item>
        <el-form-item>
            <el-button type="primary"
                       @click="onSaveBasicData"
                       :disabled="isSubmitted || $v.event.$invalid">
                Salvar Alterações
            </el-button>
            <form-cancel-button route-name="event.index"/>
        </el-form-item>
    </el-form>
</template>



// WEBPACK FOOTER //
// BasicData.vue?491b4998